'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Modal } from '@repo/design-system/components/ui/modal';
import { toast } from '@repo/design-system/components/ui/toaster';
import { Type } from '@repo/design-system/components/ui/type';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useResetAllFoundPinsMutation } from '@repo/store/maps/api/mapsApi';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectAuthState } from '@repo/store/maps/slices/auth';
import { selectExternalMapId } from '@repo/store/maps/slices/mapData';
import { useState } from 'react';
import { Trans } from 'react-i18next';
export const ResetFoundPins = () => {
  const $ = _c(51);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const externalMapId = useAppSelector(selectExternalMapId);
  const hostType = useHostType();
  const [resetAllFoundPins, t0] = useResetAllFoundPinsMutation();
  const {
    isLoading: isResetting
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map", "common"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const analytics = useAnalytics();
  const auth = useAppSelector(selectAuthState);
  let t2;
  if ($[1] !== analytics || $[2] !== externalMapId || $[3] !== hostType) {
    t2 = () => {
      setIsModalOpen(true);
      if (analytics && externalMapId && hostType) {
        analytics.event("game_map_reset_found_pins_click", {
          mapId: externalMapId,
          platform: hostType
        });
      }
    };
    $[1] = analytics;
    $[2] = externalMapId;
    $[3] = hostType;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleResetClick = t2;
  let t3;
  if ($[5] !== analytics || $[6] !== externalMapId || $[7] !== hostType || $[8] !== resetAllFoundPins || $[9] !== t) {
    t3 = async () => {
      if (!externalMapId) {
        return;
      }
      try {
        await resetAllFoundPins(externalMapId).unwrap();
        setIsModalOpen(false);
        analytics.event("game_map_reset_found_pins_confirm", {
          mapId: externalMapId,
          platform: hostType
        });
        toast({
          title: t(_temp),
          description: t(_temp2),
          variant: "success"
        });
      } catch {
        toast({
          title: t(_temp3),
          description: t(_temp4),
          variant: "error"
        });
      }
    };
    $[5] = analytics;
    $[6] = externalMapId;
    $[7] = hostType;
    $[8] = resetAllFoundPins;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleConfirmReset = t3;
  let t4;
  if ($[11] !== analytics || $[12] !== externalMapId || $[13] !== hostType) {
    t4 = () => {
      setIsModalOpen(false);
      if (analytics && externalMapId && hostType) {
        analytics.event("game_map_reset_found_pins_cancel", {
          mapId: externalMapId,
          platform: hostType
        });
      }
    };
    $[11] = analytics;
    $[12] = externalMapId;
    $[13] = hostType;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleCancel = t4;
  const t5 = !externalMapId || !auth.user;
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon icon="delete_sweep" decorative={true} />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t(_temp5);
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleResetClick || $[19] !== t5 || $[20] !== t7) {
    t8 = <Button onClick={handleResetClick} color="secondary" size="md" disabled={t5}>{t6}{t7}</Button>;
    $[18] = handleResetClick;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t(_temp6);
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = details => setIsModalOpen(details.open);
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Type variant="body-s" color="white"><Trans i18nKey={_temp7} ns="game_map" /></Type>;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = css({
      flex: "1"
    });
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== isResetting || $[28] !== t) {
    t13 = isResetting ? t(_temp8, {
      ns: "common"
    }) : t(_temp9);
    $[27] = isResetting;
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== handleConfirmReset || $[31] !== isResetting || $[32] !== t13) {
    t14 = <Button onClick={handleConfirmReset} color="warning" size="lg" disabled={isResetting} className={t12}>{t13}</Button>;
    $[30] = handleConfirmReset;
    $[31] = isResetting;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = css({
      flex: "1"
    });
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = t(_temp10);
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== handleCancel || $[38] !== isResetting || $[39] !== t16) {
    t17 = <Button onClick={handleCancel} color="secondary" size="lg" disabled={isResetting} className={t15}>{t16}</Button>;
    $[37] = handleCancel;
    $[38] = isResetting;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t14 || $[42] !== t17) {
    t18 = <FlexColumn gap="12">{t11}<FlexRow gap="8" justify="end" width="full">{t14}{t17}</FlexRow></FlexColumn>;
    $[41] = t14;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== isModalOpen || $[45] !== t18 || $[46] !== t9) {
    t19 = <Modal title={t9} isOpen={isModalOpen} onOpenChange={t10} size="sm" hideCloseButton={true}>{t18}</Modal>;
    $[44] = isModalOpen;
    $[45] = t18;
    $[46] = t9;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t19 || $[49] !== t8) {
    t20 = <FlexColumn align="center" justify="center">{t8}{t19}</FlexColumn>;
    $[48] = t19;
    $[49] = t8;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
};
function _temp($_1) {
  return $_1.success;
}
function _temp2($_2) {
  return $_2.all_found_pins_reset;
}
function _temp3($) {
  return $.error;
}
function _temp4($_0) {
  return $_0.failed_to_reset_found_pins;
}
function _temp5($_3) {
  return $_3.reset_found_pins;
}
function _temp6($_4) {
  return $_4.reset_all_found_pins;
}
function _temp7($_5) {
  return $_5.this_will_mark_all_pins;
}
function _temp8($_6) {
  return $_6.loading;
}
function _temp9($_7) {
  return $_7.yes_reset;
}
function _temp10($_8) {
  return $_8.cancel;
}